module.exports = __webpack_public_path__ + "static/media/21ECLAC37.b50e6bd3.jpg";